import UserTableService from 'app/admin/user/service/UserTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import AddMeasurementTaskButton from 'app/admin/common/component/AddMeasurementTaskButton';
import AddMeasurementButton from 'app/admin/common/component/AddMeasurementButton';
import PiMeasurementReaderTableService from '../service/PiMeasurementReaderTableService';
import PiMeasurementReaderService from '../service/PiMeasurementReaderService';

const config = {
	key: 'piMeasurementReaderTable',
	topic: 'piMeasurementReader',
	service: PiMeasurementReaderTableService,
	editFormState: item => `/pi-measurement-reader/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	rowButtonList: [/*{ key: 'addPiMeasurementTaskManager', component: AddMeasurementTaskButton },*/ { key: 'addMeasurement', component: AddMeasurementButton, service: PiMeasurementReaderService }],
	columns: [
		{
			key: 'name'
		},
		// {
		// 	key: 'username'
		// },
		{
			key: 'api_url'
		},
		// {
		// 	key: 'server_id'
		// },
		// {
		// 	key: 'time_zone'
		// }
	]
};

function PiMeasurementReaderTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('piMeasurementReaderTable', reducer('piMeasurementReaderTable'))(PiMeasurementReaderTable);
